import { useDialog } from '../DialogProvider/DialogProvider';
import './BookDemo.css'
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { bookADemo } from '../../services/httpService';

export const bookDemoSchema = yup.object({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    organization: yup.string().required('Organization is required'),
    demoDate: yup.string().required('Preferred date & time is required'),
    questions: yup
        .string()
        .required('Please enter your questions')
        .max(500, 'Maximum 500 characters'),
});
function BookDemo({ show }) {
    const { openDialog, closeDialog, animation } = useDialog();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting }
    } = useForm({
        resolver: yupResolver(bookDemoSchema)
    });
    const onSubmit = async (data) => {
        const payload = {
            fullname: `${data.firstName} ${data.lastName}`,
            organization: data.organization,
            demoDate: data.demoDate,
            questions: data.questions,
        };
        await bookADemo(payload, reset, openDialog);
    };

    if (!show) return null;
    return (
        <div className='popup-wrapper'>
            <div
                className='BookDemo popup-body animation'
                style={{ animationName: animation }}
            >
                <div className='BookDemo-left'>
                    <div className='bold-heading'>Schedule Your BrainyClock Demo</div>
                    <div className='theme-text-small-16'>
                        Discover how BrainyClock can enhance your time tracking with a
                        personalized demonstration. Please fill out the form below to
                        schedule your session.
                    </div>
                </div>

                <form className='BookDemo-right' onSubmit={handleSubmit(onSubmit)}>
                    <div className='d-flex flex-column gap-16'>
                        <div className='form-group'>
                            <label>First Name</label>
                            <input type='text' {...register('firstName')} />
                            {errors.firstName && (
                                <span className='error text-danger'>{errors.firstName.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Last Name</label>
                            <input type='text' {...register('lastName')} />
                            {errors.lastName && (
                                <span className='error text-danger'>{errors.lastName.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Organization</label>
                            <input type='text' {...register('organization')} />
                            {errors.organization && (
                                <span className='error text-danger'>{errors.organization.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Preferred Demo Date and Time</label>
                            <input type='text' {...register('demoDate')} />
                            {errors.demoDate && (
                                <span className='error text-danger'>{errors.demoDate.message}</span>
                            )}
                        </div>

                        <div className='form-group'>
                            <label>Any Specific Questions?</label>
                            <textarea
                                style={{ height: '100px' }}
                                {...register('questions')}
                            />
                            {errors.questions && (
                                <span className='error text-danger'>{errors.questions.message}</span>
                            )}
                        </div>
                    </div>

                    <div className='d-flex gap-24 BookDemo_btn_container'>
                        <button
                            type='button'
                            className='menu-outline-btn-theme'
                            onClick={() => { reset(); closeDialog() }}
                        >
                            Discard
                        </button>
                        <button type='submit' className='menu-btn-theme w-100' disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'Schedule My Demo'}
                        </button>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default BookDemo
